import { FormOutlined } from "@ant-design/icons";
import { Form, Space } from "antd";
import { ColumnsType } from "antd/lib/table";
import React, { useState } from "react";
import "./style.scss";
import { AddNewsModal, EditNewsModal, MenuPage } from "components";
import { api } from "services/api";

export const ManageNews: React.FC = () => {
	const [refreshTable, setRefreshTable] = useState<boolean>(false);
	const [isOpen, setIsOpen] = useState<boolean>(false);
	const [isOpenEdit, setIsOpenEdit] = useState<boolean>(false);
	const [currentImgURL, setCurrentImgURL] = useState<string>("");
	const [newsStatus, setNewsStatus] = useState<boolean>(false);
	const [newsIsHighlight, setNewsIsHighlight] = useState<boolean>(false);
	const [currentNewsInfo, setCurrentNewsInfo] = useState<any[]>([]);
	const [form] = Form.useForm();
	const [editForm] = Form.useForm();

	const getUpdatedInfo = async (id: string) => {
		const {
			data: {
				data: { news },
			},
		} = await api.get(`/news/${id}`);

		setCurrentNewsInfo(news);
	};

	const columns: ColumnsType<any> = [
		{
			title: "Título da notícia",
			dataIndex: "title",
			key: "title",
			render: (text) => <p style={{ margin: 0 }}>{text}</p>,
			onCell: () => {
				return {
					width: "12%",
				};
			},
		},
		{
			title: "Descrição",
			dataIndex: "description",
			key: "description",
		},
		{
			title: "Cadastrado em",
			dataIndex: "created_at",
			key: "created_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Última edição",
			dataIndex: "updated_at",
			key: "updated_at",
			render: (text) => <p style={{ margin: 0 }}>{text ? text : "-"}</p>,
			onCell: () => {
				return {
					width: "11%",
				};
			},
		},
		{
			title: "Status",
			dataIndex: "status",
			key: "status",
			render: (status) => (
				<p style={{ margin: 0 }}>
					{status === "publish" ? "Publicado" : "Desativado"}
				</p>
			),
		},
		{
			title: "Ativo",
			dataIndex: "is_active",
			key: "is_active",
			render: (active) => (
				<p style={{ margin: 0 }}>{active === true ? "Sim" : "Não"}</p>
			),
		},
		{
			title: "",
			key: "",
			render: (_, record) => (
				<Space size="middle">
					<FormOutlined
						className="edit"
						onClick={async () => {
							await getUpdatedInfo(`${record?.id}`);
							setIsOpenEdit(true);
						}}
					/>
				</Space>
			),
		},
	];

	const handleClickAdd = () => { setIsOpen(true)}
	const handleRefresh = () => {
		setRefreshTable(true);
		setTimeout(() => {
		  	setRefreshTable(false);
		}, 1000);
	};
	const getTableDataFromResponse = (responseData: any) => {
		return responseData.data.news;
	}

	return (
		<div className="m-news">
			<AddNewsModal
				form={form}
				isOpen={isOpen}
				setIsOpen={setIsOpen}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				newsStatus={newsStatus}
				setNewsStatus={setNewsStatus}
				newsIsHighlight={newsIsHighlight}
				setNewsIsHighlight={setNewsIsHighlight}
				onCreated={handleRefresh}
			/>
			<EditNewsModal
				form={editForm}
				isOpen={isOpenEdit}
				setIsOpen={setIsOpenEdit}
				currentImgURL={currentImgURL}
				setCurrentImgURL={setCurrentImgURL}
				newsStatus={newsStatus}
				setNewsStatus={setNewsStatus}
				newsIsHighlight={newsIsHighlight}
				setNewsIsHighlight={setNewsIsHighlight}
				currentNewsInfo={currentNewsInfo}
				onUpdated={handleRefresh}
			/>

			<MenuPage 
				title="Notícias" 
				tableColumns={columns} 
				sourceDataUrl={'/news'}  
				getDataFromResponse={getTableDataFromResponse} 
				addButtonText="+ Adicionar Notícia" 
				onClickAdd={handleClickAdd} 
				refreshData={refreshTable}
				searchPlaceholder="Busque por título ou descrição"
			/>
		</div>
	);
};
